import React, { ReactElement } from 'react';
import { Button, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import WarningIcon from '@mui/icons-material/Warning';
import { ListItemIcon } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { ReactComponent as TI503Icon } from './icons/TimeIntelligence_503_Icon.svg';
import { useGoToHome } from './hooks/useGoToHome';
import { ErrorPageType } from './types';
import { useErrorPageStyles } from './hooks/useErrorPageStyles';
import ZeroTime_Logo_Error_Pages from './logo/ZeroTime_Logo_Error_Pages.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    justifyContent: 'space-evenly'
  },
  icon: {
    color: theme.palette.error.main,
    fontSize: '8vh',
    marginTop: '-10vh',
    marginBottom: theme.spacing(2)
  }
}));

const ErrorPage_503 = ({ ecid }: ErrorPageType): ReactElement => {
  const iconStyles = useStyles();

  const { goToHome } = useGoToHome();
  const classes = useErrorPageStyles();
  return (
    <div data-testid="error-page-503" className={classes.root}>
      <img src={ZeroTime_Logo_Error_Pages} alt="Zt Logo" />

      <ListItemIcon>
        <TI503Icon className={classes.icon} />
      </ListItemIcon>
      <ListItemIcon className={iconStyles.root}>
        <WarningIcon className={iconStyles.icon} />
      </ListItemIcon>

      <Typography variant="h2" className={classes.titleText}>
        <FormattedMessage id="errorPage._503.title" />
      </Typography>
      <Typography variant="h6" className={classes.subTitleText}>
        <FormattedMessage id="errorPage._503.subText" />
      </Typography>
      <Button
        className={classes.button}
        color="primary"
        variant="contained"
        onClick={goToHome}
        size="large"
      >
        <FormattedMessage id="errorPage._503.buttonText" />
      </Button>
      <Typography variant="body1" data-testid="ecid-container">
        <span className={classes.nerdStuff}>
          <FormattedMessage id="errorPage.nerdStuffLabel" />
        </span>{' '}
        {ecid}
      </Typography>
    </div>
  );
};

export default ErrorPage_503;
